import { asDarkSvg, asDisabledSvg, asLightSvg } from '../../hocs';
import SidebarAlignLeftSvg from './SidebarAlignLeftSvg';

const LightSidebarAlignLeftSvg = asLightSvg(SidebarAlignLeftSvg);
const DarkSidebarAlignLeftSvg = asDarkSvg(SidebarAlignLeftSvg);
const DisabledSidebarAlignLeftSvg = asDisabledSvg(SidebarAlignLeftSvg);

export default SidebarAlignLeftSvg;
export { SidebarAlignLeftSvg, LightSidebarAlignLeftSvg, DarkSidebarAlignLeftSvg, DisabledSidebarAlignLeftSvg };
